export default {
  modalLinkText: {
    id: 'product_page_ecoblock_modal_link_text',
    defaultMessage: 'See how renewed phones help the planet',
  },
}
